import React, {useEffect, useState} from "react";
import {useStorehouseContext} from "../StorehouseContext";
import ViaqSelectBox from "../../../components/atoms/ViaqSelectBox";
import Modal from "../../../components/atoms/Modal";
import Icon from "../../../components/atoms/Icon";
import InputGroup from "../../../components/atoms/InputGroup";
import BtnModal from "../../../components/atoms/BtnModal";
import toast from "react-hot-toast";

const AddDeviceModal = () => {
    const {
        modalState,
        closeModal,
        searchModels,
        openModal,
        addDeviceStateUpdate,
        addDeviceState,
        generateBrokerPassword,
        addDeviceToStorehouse
    } = useStorehouseContext();

    const [formValues, setFormValues] = useState({
        selectedModel: "",
        broker: "",
        serialNumber: ""
    })
    useEffect(() => {
        setFormValues({
            modelId: "",
            broker: "",
            serialNumber: ""
        })
    }, [modalState]);


    const handleUpdateFormValues = (key, value) => {
        console.log(key + " -> " + value)
        setFormValues(prevState => ({...prevState, [key]: value}))
    }

    const onCreatePasswordClick = () => {
        handleUpdateFormValues("broker", generateBrokerPassword())
    }

    const onSelectModel = (data) => {
        if (data) {
            handleUpdateFormValues("serialNumber", data[0].serialNumber)
            handleUpdateFormValues("modelId", data[0].value)
        }
    }
    const searchFunction = (props) => {

        if (props.state.value !== "") {
            searchModels(props)
        }

    }

    const onBtnClick = () => {
        if (formValues.broker !== "" && formValues.modelId !== "") {
            addDeviceToStorehouse(formValues)
        } else {
            toast.error("موارد خواسته شده را وارد کنید")
        }
    }


    const isOpen = modalState.mode === "add" && modalState.isOpen;
    if (!isOpen) {
        return null;
    }
    return (
        <>
            <Modal title={"افزودن دستگاه جدید"} closeModal={closeModal}>
                <div className="flex flex-col gap-5">
                    <ViaqSelectBox
                        label="مدل دستگاه"
                        iconName="setting"
                        placeholder={"مدل دستگاه را انتخاب کنید"}
                        showIcon={true}
                        disabled={false}
                        defaultValue={null}
                        values={addDeviceState.findModels}
                        onChange={onSelectModel}
                        searchFunction={searchFunction}
                        loading={addDeviceState.searchLoading}
                    />

                    <div className="flex flex-col w-full">
                        <label
                            htmlFor="name"
                            className="text-dark-blue-200 text-12 font-normal leading-5 mb-2.5">
                            رمز بروکر
                        </label>
                        <div
                            className="flex flex-row justify-between  bg-gray-chart-200 w-full px-3.5 gap-2.5 items-center rounded-sm  h-12.6">
                            <div className="flex flex-row items-center gap-2.5">
                                <Icon iconName="password-check"/>
                                <input
                                    value={formValues.broker}
                                    id="brokerpass"
                                    type="text"
                                    placeholder={" 954tM95nKJE# "}
                                    className="bg-gray-chart-200 outline-none text-dark-blue-200 text-14 py-3.5"

                                    onChange={(event) => handleUpdateFormValues("broker", event.target.value)}
                                />
                            </div>
                            <button
                                onClick={onCreatePasswordClick}
                                className="flex flex-row justify-center items-center w-36 font-normal text-12  text-dark-blue-200 leading-5 border-r-1 border-gray3 pr-2.5">
                                ساخت کلمه عبور اتفاقی
                            </button>
                        </div>
                    </div>
                    <InputGroup
                        placeholder={" V-AAQ01ih2210002 مانند  "}
                        label="شماره سریال (تولید به صورت خودکار)"
                        iconName={"cpuB"}
                        readOnly={true}
                        disabled={true}
                        value={formValues.serialNumber}
                        id="serialNumber"
                    />
                    <div className="flex items-center justify-end">
                        <BtnModal
                            showloading={addDeviceStateUpdate.addDeviceLoading}
                            text={"افزودن دستگاه"}
                            accept={onBtnClick}
                        />
                    </div>

                </div>
            </Modal>
        </>
    );
};

export default AddDeviceModal;
